import { Pipe, PipeTransform } from '@angular/core';
import { of } from 'rxjs';

@Pipe({
  name: 'customTimeZone'
})
export class CustomTimeZonePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let modifiedVal:any="";
    if(value!="" && value!=null && value!=undefined){
      if(parseInt(value.split(":")[0]) < 12){
        modifiedVal = value +" AM";
      }
      if(parseInt(value.split(":")[0]) >= 12){
        modifiedVal = value +" PM";
      }
    }
    return modifiedVal;
  }

}
